import { DeepPartial, DotVotingStageOptions, GroupingStageOptions, Idea, IdeaEnhanced, IdeaGroup, IdeaGroupEnhanced, IdeationStageOptions, IdeationStep, StageOptions, SummedIdea, SummedIdeaEnhanced } from '@proj-common/types'

export function isIdea(idea: SummedIdea | DeepPartial<SummedIdea>): idea is Idea {
    return (idea as Idea).participant_id !== undefined
}

export function isIdeaGroup(idea: SummedIdea | DeepPartial<SummedIdea>): idea is IdeaGroup {
    return (idea as IdeaGroup).ideas !== undefined
}

export function isIdeaEnhanced(idea: SummedIdeaEnhanced): idea is IdeaEnhanced {
    return (idea as IdeaEnhanced).participant_id !== undefined
}

export function isIdeaGroupEnhanced(idea: SummedIdeaEnhanced): idea is IdeaGroupEnhanced {
    return (idea as IdeaGroupEnhanced).ideas !== undefined
}

export function isIdeationStageOptions(options: StageOptions): options is IdeationStageOptions {
    return (options as IdeationStageOptions)?.steps !== undefined
}

export function isDotVotingStageOptions(options: StageOptions): options is DotVotingStageOptions {
    return (options as DotVotingStageOptions)?.ideation_stage_id !== undefined && (options as DotVotingStageOptions)?.rules !== undefined 
}

export function isGroupingStageOptions(options: StageOptions): options is GroupingStageOptions {
    return (options as GroupingStageOptions)?.ideation_stage_id !== undefined && (options as DotVotingStageOptions)?.rules === undefined 
}

export function isIdeationStep(step: IdeationStep | string): step is IdeationStep {
    if (typeof step === 'string') return false
    return (step as IdeationStep).id !== undefined
}